import { h } from 'preact';
import React, { Component } from 'react';
import SearchSVG from '../Components/Search.svg';
import Accordion from '../Components/Accordion';
import { VendorContent } from './VendorContent';
import { makeText, isActionAllowed } from '../../../util';
import { lockedVendors } from '../../../constants';

export default class Vendors extends Component {
  state = {
    filter: '',
    selected: this.props.startWithLiToggled ? 'li' : 'consent',
  }

  updateFilter = (e) => this.setState({ filter: e.target.value });

  render() {
    const { vendors, settings, language, dev, usePurModel, idfaStatus } = this.props;
    const { filter, selected } = this.state;

    const filteredVendors = vendors
      .filter(v => selected === 'consent' ? v.consentCategories.length : (v.legIntCategories.length || v.disclosureOnlyCategories.length))
      .filter(v => filter === '' || v.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);

    const searchText = makeText(Boolean(dev), settings, 'searchText', language);
    const otherText = makeText(Boolean(dev), settings, 'otherText', language);
    const otherLetter = makeText(Boolean(dev), settings, 'otherLetter', language);
    const consentText = makeText(Boolean(dev), settings, 'vendorConsentText', language);
    const liText = makeText(Boolean(dev), settings, 'vendorLiText', language);

    const appleDataBrokerText = makeText(Boolean(dev), settings, 'appleDataBrokerText', language);
    const appleDataBrokerLetter = makeText(Boolean(dev), settings, 'appleDataBrokerLetter', language);
    const isAnyAppleDataBroker = Boolean(filteredVendors.some(v => v.isApple));

    const customVendorLabel1Text = makeText(Boolean(dev), settings, 'customVendorLabel1Text', language);
    const customVendorLabel2Text = makeText(Boolean(dev), settings, 'customVendorLabel2Text', language);
    const customVendorLabel3Text = makeText(Boolean(dev), settings, 'customVendorLabel3Text', language);
    const customVendorLabel1Letter = makeText(Boolean(dev), settings, 'customVendorLabel1Letter', language);
    const customVendorLabel2Letter = makeText(Boolean(dev), settings, 'customVendorLabel2Letter', language);
    const customVendorLabel3Letter = makeText(Boolean(dev), settings, 'customVendorLabel3Letter', language);

    const isAnyCustomVendorLabel1 = Boolean(filteredVendors.some(v => v.isCustomVendorLabel1));
    const isAnyCustomVendorLabel2 = Boolean(filteredVendors.some(v => v.isCustomVendorLabel2));
    const isAnyCustomVendorLabel3 = Boolean(filteredVendors.some(v => v.isCustomVendorLabel3));
    const hasLegIntVendors = vendors.some(v => v.legInt);

    const vendorTitleText = makeText(Boolean(dev), settings, 'vendorTitleText', language)

    return (
      <div className="pm-features pm-vendors">
        {hasLegIntVendors ?
          (<div className="pm-type-toggle">
            <div
              id="vendors-focus"
              tabindex="0"
              className="focusable"
              onClick={() => this.setState({ selected: 'consent' })} onKeyDown={(e) => isActionAllowed(e.key) && this.setState({ selected: 'consent' })}>{consentText}</div>
            <div
              tabindex="0"
              onClick={() => this.setState({ selected: 'li' })}
              onKeyDown={(e) => isActionAllowed(e.key) && this.setState({ selected: 'li' })}>{liText}</div>
            <span className={selected === 'li' ? 'selected li' : 'selected consent'} />
          </div>) : null
        }
        <div className="filter-container">
          <img src={SearchSVG} alt="" />
          <input
            className="vendor-filter"
            aria-label="vendors search filter"
            placeholder={`${searchText}...`}
            name="filter"
            value={filter}
            onChange={this.updateFilter}
          />
          <div role="status" aria-live="polite">{filteredVendors.length ? `${filteredVendors.length} vendor${filteredVendors.length === 1 ? '' : 's'} found` : 'No Vendors Found'}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ color: '#000', fontWeight: 'normal' }}>
             {filteredVendors.length} {vendorTitleText}
          </h3>
          <div className="legend" style={{ margin: 0 }}>
            <span className="legend-key" aria-hidden>
              {otherLetter}
            </span>
            <h2 class="custom-header">
              {otherText}
            </h2>
            {isAnyAppleDataBroker && (
              <span className="legend-key apple-broker" aria-hidden>
                {appleDataBrokerLetter}
              </span>
            )}
            {isAnyAppleDataBroker && appleDataBrokerText}

            {isAnyCustomVendorLabel1 && (
              <span className="legend-key is-custom-vendor-label-1" aria-hidden>
                {customVendorLabel1Letter}
              </span>
            )}
            {isAnyCustomVendorLabel1 && customVendorLabel1Text}
            {isAnyCustomVendorLabel2 && (
              <span className="legend-key is-custom-vendor-label-2" aria-hidden>
                {customVendorLabel2Letter}
              </span>
            )}
            {isAnyCustomVendorLabel2 && customVendorLabel2Text}
            {isAnyCustomVendorLabel3 && (
              <span className="legend-key is-custom-vendor-label-3" aria-hidden>
                {customVendorLabel3Letter}
              </span>
            )}
            {isAnyCustomVendorLabel3 && customVendorLabel3Text}
          </div>
        </div>
        {filteredVendors.map(v => {
          const canToggle = v.disclosureOnlyCategories.length > 0 && v.legIntCategories <= 0 && v.consentCategories <= 0 ? false : true;
          const specialToggle = (v.iabSpecialPurposes.length > 0 || v.iabFeatures.length > 0) && v.consentCategories <= 0 && v.legIntCategories.length <= 0 && v.iabSpecialFeatures <= 0 ? true : false;
          const isApple = v.isApple;
          const isCustomVendorLabel1 = v.isCustomVendorLabel1;
          const isCustomVendorLabel2 = v.isCustomVendorLabel2;
          const isCustomVendorLabel3 = v.isCustomVendorLabel3;
          const appleTrackingRejected = (idfaStatus === 'unknown' || idfaStatus === 'denied');
          const hideAppleToggle = isApple && appleTrackingRejected;

          return (
            <Accordion
              key={`vendor-${v.vendorId}`}
              settings={this.props.settings}
              name={(
                <span role="text">
                  {v.name}{v.vendorType !== 'IAB' && (
                    <span className="legend-key inline" aria-hidden>
                      {otherLetter}
                    </span>
                  )}
                </span>
              )}
              isCustom={v.vendorType !== 'IAB'}
              locked={lockedVendors.includes(v.iabId) || hideAppleToggle}
              description={v.name}
              child="vendors"
              language={language}
              value={v}
              content={<VendorContent dev={dev} vendor={v} settings={settings} language={language} consentType={selected} />}
              toggle={canToggle && !specialToggle ? this.props.toggleVendor : null}
              consentType={selected === 'consent' ? 'active' : 'legInt'}
              selected={selected === 'consent' ? 'active' : 'li'}
              isApple={isApple}
              appleDataBrokerLetter={appleDataBrokerLetter}
              usePurModel={usePurModel && this.state.selected !== 'li'}
              isCustomVendorLabel1={isCustomVendorLabel1}
              isCustomVendorLabel2={isCustomVendorLabel2}
              isCustomVendorLabel3={isCustomVendorLabel3}
              appleDataBrokerLetter={appleDataBrokerLetter}
              customVendorLabel1Letter={customVendorLabel1Letter}
              customVendorLabel2Letter={customVendorLabel2Letter}
              customVendorLabel3Letter={customVendorLabel3Letter}
            />
          );
        }
        )}
      </div>
    );
  }
}
